import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { GridRowModes, GridRowModesModel } from '@mui/x-data-grid';
import { QuantitativeMetricRecordGridRow } from './QuantitativeMetricRecordGrid';
import GhostButton from '../../shared/button/GhostButton';
import PrimaryButton from '../../shared/button/PrimaryButton';

interface EditAverageRecordModalProps {
  open: boolean;
  action_row: QuantitativeMetricRecordGridRow;
  row_modes_model: GridRowModesModel;
  message: string;
  handleCloseEditModal: () => void;
  setRowModesModel: (GridRowModesModel: GridRowModesModel) => void;
}

const EditAverageRecordModal = (props: EditAverageRecordModalProps) => {
  const handleConfirm = () => {
    props.setRowModesModel({
      ...props.row_modes_model,
      [props.action_row.id]: { mode: GridRowModes.Edit }
    });
    props.handleCloseEditModal();
  };

  const handleCancel = () => {
    props.handleCloseEditModal();
  };

  return (
    <React.Fragment>
      <Dialog open={props.open} onClose={handleCancel}>
        <DialogTitle>Confirm Edit Averaged Value</DialogTitle>
        <DialogContent>
          <DialogContentText textAlign={'justify'}>{props.message}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <GhostButton outlined dark onClick={handleCancel}>
            Cancel
          </GhostButton>
          <PrimaryButton onClick={handleConfirm} palette_color="error">
            Confirm
          </PrimaryButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default EditAverageRecordModal;
